import { Link } from 'react-router-dom';

const SecuritySection = () => (
  <section className="relative bg-background-100 py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
        <div className="lg:w-3/5">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full mb-4">
            Segurança &amp; EEAT
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.1]">
            Links Verificados.<br />
            Dados Protegidos.<br />
            Compra Segura.
          </h2>
          <p className="mt-6 text-sm text-foreground-600 leading-relaxed max-w-lg">
            Todas as recomendações do <strong>Hoobuy Spreadsheet</strong> são verificadas antes da publicação. Utilizamos criptografia SSL de ponta e proteção de dados com monitoramento contínuo 24 horas. Fornecedores auditados pela nossa equipe especializada.
          </p>

          <div className="flex flex-wrap gap-3 mt-8">
            <Link
              to="/artigo/guia-completo-hoobuy-spreadsheet-2026"
              className="inline-flex items-center px-5 py-2.5 bg-background-50 border border-background-300 rounded-full text-sm font-medium text-foreground-950 hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Guia: Hoobuy Spreadsheet 2026
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-5 py-2.5 bg-background-50 border border-background-300 rounded-full text-sm font-medium text-foreground-950 hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explorar Produtos
            </a>
          </div>
        </div>

        <div className="lg:w-2/5">
          <div className="bg-accent-500 rounded-3xl p-8 md:p-10 text-background-50 relative overflow-hidden">
            <div className="absolute top-4 right-4 flex gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-background-50/40"></span>
              <span className="w-1.5 h-1.5 rounded-full bg-background-50/40"></span>
              <span className="w-1.5 h-1.5 rounded-full bg-background-50/40"></span>
            </div>
            <p className="text-xs font-semibold uppercase tracking-wider text-background-50/60 mb-6">Nossa Equipe</p>
            <p className="text-lg md:text-xl leading-relaxed font-heading italic">
              &ldquo;Analisamos diariamente todos os links do <strong>Hoobuy Spreadsheet</strong> para garantir a melhor experiência aos usuários do Brasil e Portugal.&rdquo;
            </p>
            <div className="flex items-center gap-4 mt-8 pt-6 border-t border-background-50/15">
              <div className="w-10 h-10 rounded-full bg-background-50/15 flex items-center justify-center">
                <i className="ri-shield-check-line text-background-50 text-lg"></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-background-50">Equipe Hoobuy.homes</p>
                <p className="text-xs text-background-50/60">Verificado 2026</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default SecuritySection;